/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import rgba from "assets/theme-dark/functions/rgba";

const { ink, accent, text } = colors;
const { borderRadius } = borders;
const { size } = typography;

// Redesign: hover = subtle ink overlay; selected = soft accent fill + accent label.
const menuItem = {
  styleOverrides: {
    root: {
      minWidth: pxToRem(160),
      minHeight: "unset",
      padding: `${pxToRem(6)} ${pxToRem(12)}`,
      borderRadius: borderRadius.sm,
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 200ms ease, color 200ms ease",

      "&:hover, &:focus": {
        backgroundColor: rgba(ink.main, 0.08),
        color: ink.main,
      },

      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: accent.soft,
        color: accent.main,
      },
    },
  },
};

export default menuItem;
